import axios from "axios";
import { useState, useEffect, MouseEvent } from "react";
import { BsBoxArrowRight, BsFile, BsFilePlay, BsFiles, BsHouse, BsPeople, BsPersonCircle, BsPersonRolodex, BsShield } from "react-icons/bs"
import { useLocation, useNavigate } from "react-router-dom";
import pulpliveworldlogo from "../assets/img/Logo_Pulp_Full_Black.png";

export default function Sidebar() {
    const [author, setAuthor] = useState<string | null>(null);
    const [role, setRole] = useState<string | null>(null);

    useEffect(() => {
        const storedAuthor = localStorage.getItem('author');
        const storedRole = localStorage.getItem('role');
        if (storedAuthor) {
            setAuthor(storedAuthor);
        }
        if (storedRole) {
            setRole(storedRole);
        }
    }, []);
    const navigate = useNavigate();

    const location = useLocation();

    const isActive = (path: string) => location.pathname === path;


    const handleLogout: React.MouseEventHandler<HTMLAnchorElement> = async (e) => {
        e.preventDefault();

        try {
        await axios.post('https://cdn.pulp.ph/api/logout', {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            }
        });
        // Clear the token from localStorage
        localStorage.removeItem('authToken');
        localStorage.removeItem('author');
        localStorage.removeItem('role');
        // Optionally, clear the default Authorization header for Axios
        delete axios.defaults.headers.common['Authorization'];
        // Redirect to the login page
        alert('Logged Out Successfully');
        window.location.href = '/login';
    } catch (error) {
        alert('Unauthenticated Please Login');
        window.location.href = '/login';
    }
    };


    return (
        <>
            <aside className="w-80 ">
                <div className="p-4 text-center">
                    <div className="pulp-logo flex items-center justify-center h-auto w-auto">
                        <img src={pulpliveworldlogo} className="h-auto w-[150px]" alt="pulp logo" />

                    </div>
                    <br />
                    <br />
                    <div className="profile container flex items-center space-x-4">
                        <div className="picture flex items-center justify-center">
                            <BsPersonCircle className="text-5xl" />
                        </div>
                        <div className="name-role-container">
                            <h2 className="font-semibold text-lg">{author}</h2>
                            <p className="text-sm"><i>{role}</i></p>
                        </div>
                    </div>
                </div>
                <nav className="mt-5">
                    <ul>
                        <li className={`hover:text-red-500 hover:font-semibold hover:bg-gray-300 ${isActive('/view/post/Show') ? 'text-red-500 font-semibold' : ''}`}>
                            <a href="/view/post/Show" aria-current={isActive('/view/post/Show') ? 'page' : undefined} className="flex items-center p-3">
                                <BsFile className="mr-3" /> Shows
                            </a>
                        </li>
                        <li className={`hover:text-red-500 hover:font-semibold hover:bg-gray-300 ${isActive('/view/post/ticket') ? 'text-red-500 font-semibold' : ''}`}>
                            <a href="/view/post/ticket" aria-current={isActive('/view/post/ticket') ? 'page' : undefined} className="flex items-center p-3">
                                <BsFiles className="mr-3" /> Ticket
                            </a>
                        </li>
                        <li className={`hover:text-red-500 hover:font-semibold hover:bg-gray-300 ${isActive('/view/post/seatPlan') ? 'text-red-500 font-semibold' : ''}`}>
                            <a href="/view/post/seatPlan" aria-current={isActive('/view/post/seatPlan') ? 'page' : undefined} className="flex items-center p-3">
                                <BsPeople className="mr-3" /> Seat Plan
                            </a>
                        </li>
                        <li className={`hover:text-red-500 hover:font-semibold hover:bg-gray-300 ${isActive('/view/post/ticket-prices') ? 'text-red-500 font-semibold' : ''}`}>
                            <a href="/view/post/ticket-prices" aria-current={isActive('/view/post/ticket-prices') ? 'page' : undefined} className="flex items-center p-3">
                                <BsPersonRolodex className="mr-3" /> Ticket Prices
                            </a>
                        </li>

                        <li className={`hover:text-red-500 hover:font-semibold hover:bg-gray-300 ${isActive('/view/post/buy-links') ? 'text-red-500 font-semibold' : ''}`}>
                            <a href="/view/post/buy-links" aria-current={isActive('/view/post/buy-links') ? 'page' : undefined} className="flex items-center p-3">
                                <BsPersonRolodex className="mr-3" /> Buy Links
                            </a>
                        </li>
                        <li className={`hover:text-red-500 hover:font-semibold hover:bg-gray-300 ${isActive('/view/post/video') ? 'text-red-500 font-semibold' : ''}`}>
                            <a href="/view/post/video" aria-current={isActive('/view/post/video') ? 'page' : undefined} className="flex items-center p-3">
                                <BsFilePlay className="mr-3" /> Video
                            </a>
                        </li>

                        <li className={`hover:text-red-500 hover:font-semibold hover:bg-gray-300 ${isActive('/view/post/gallery') ? 'text-red-500 font-semibold' : ''}`}>
                            <a href="/view/post/gallery" aria-current={isActive('/view/post/gallery') ? 'page' : undefined} className="flex items-center p-3">
                                <BsFilePlay className="mr-3" /> Gallery
                            </a>
                        </li>

                        <li className={`hover:text-red-500 hover:font-semibold hover:bg-gray-300 ${isActive('/admin') ? 'text-red-500 font-semibold' : ''}`}>
                            {/* <a href="/admin" aria-current={isActive('/admin') ? 'page' : undefined} className="flex items-center p-3">
                                <BsShield className="mr-3" /> Admin
                            </a> */}
                            <p className="flex items-center p-3" data-tooltip-id="feature"><BsShield className="mr-3" /> Admin</p>
                        </li>
                        <li className={`hover:text-red-500 hover:font-semibold hover:bg-gray-300`}>
                            <a href="/login" onClick={handleLogout} className="flex items-center p-3">
                                <BsBoxArrowRight className="mr-3" /> Logout
                            </a>
                        </li>
                    </ul>
                </nav>
            </aside>
        </>
    )
}
